import { pincodeURL, pincodeURL2, pincodeURL2_apikey } from "./JsonAPIConfig";
import { BaseAPICallsHandler } from "../NetworkClient/BaseAPICallsHandler";
import { NetworkUtils } from "../NetworkClient/NetworkUtils";

export const getDataFromPincode = async (pincode: string) => {
  const headers = NetworkUtils.shared.addCommonHeaders({})
  try {
    let response:any = await BaseAPICallsHandler.shared.makeGetRequest(headers, `${pincodeURL}${pincode}`); 
    return Promise.resolve(response);
  } catch (err: any) {
    return Promise.reject(err);
  }
}

export const getDataFromPincode2 = async (pincode: string) => {
  const headers = NetworkUtils.shared.addCommonHeaders({})
  try {
    let response:any = await BaseAPICallsHandler.shared.makeGetRequest(headers, `${pincodeURL2}?api-key=${pincodeURL2_apikey}&format=json&filters%5Bpincode%5D=${pincode}`); 
    return Promise.resolve(response);
  } catch (err: any) {
    return Promise.reject(err);
  }
}

